import { render, staticRenderFns } from "./goto_button.vue?vue&type=template&id=6f7c64f4"
import script from "./goto_button.vue?vue&type=script&lang=js"
export * from "./goto_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports